import React, {ReactElement, useContext} from 'react';
import {Typography} from '@customink/pigment-react';
import {useAppSelector} from '../../hooks';
import {useGetStoreDetailsQuery} from '../../api/storesApi';
import AccountDropdown from '../AccountDropdown';
import {MobileContext} from '../../containers/MobileProvider';
import HomepageLogo from '../HomepageLogo';
import './index.scss';

export interface Props {
  storeSlug: string;
}

interface DesktopHeaderProps {
  storeName?: string;
  storeSlug: string;
}

const DesktopHeader: React.FC<DesktopHeaderProps> = ({
  storeSlug,
  storeName
}: DesktopHeaderProps): ReactElement => {
  return (
    <div className="header">
      <div className="storeInfo">
        {storeName ? (
          <Typography variant="subHeading" className="storeName">
            {storeName}
          </Typography>
        ) : null}
      </div>
      <span className="userMenu">
        <AccountDropdown storeSlug={storeSlug} />
      </span>
    </div>
  );
};

DesktopHeader.defaultProps = {
  storeName: undefined
};

interface MobileHeaderProps {
  storeName?: string;
  storeSlug: string;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  storeSlug,
  storeName
}: MobileHeaderProps): ReactElement => {
  return (
    <div className="header mobile">
      <div className="header-topRow">
        <HomepageLogo />
        <span className="userMenu">
          <AccountDropdown storeSlug={storeSlug} />
        </span>
      </div>
      <div className="storeInfo">
        {storeName ? (
          <Typography variant="subHeading" className="storeName">
            {storeName}
          </Typography>
        ) : null}
      </div>
    </div>
  );
};

MobileHeader.defaultProps = {
  storeName: undefined
};

const Header: React.FC<Props> = ({storeSlug}: Props): ReactElement => {
  useGetStoreDetailsQuery(storeSlug);
  const storeDetails = useAppSelector(state => state.stores.storeDetails);
  const mobile = useContext(MobileContext);

  const storeName = storeDetails && storeDetails.name;
  return mobile ? (
    <MobileHeader storeSlug={storeSlug} storeName={storeName} />
  ) : (
    <DesktopHeader storeSlug={storeSlug} storeName={storeName} />
  );
};

export default Header;
